module.exports = __webpack_public_path__ + "static/media/chat-24px.190e0f49.svg";